import BaseIcon from "./BaseIcon";
import React, { ReactElement, SVGProps } from "react";

export default function CaretDown(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M11.2649 1.26492L6.26492 6.26492C6.19461 6.33515 6.0993 6.37459 5.99992 6.37459C5.90055 6.37459 5.80524 6.33515 5.73492 6.26492L0.734923 1.26492C0.668683 1.19384 0.632622 1.09981 0.634336 1.00266C0.63605 0.905512 0.675406 0.812819 0.744112 0.744113C0.812819 0.675406 0.905511 0.63605 1.00266 0.634336C1.09981 0.632622 1.19384 0.668684 1.26492 0.734924L5.99992 5.4693L10.7349 0.734924C10.806 0.668684 10.9 0.632622 10.9972 0.634336C11.0943 0.63605 11.187 0.675406 11.2557 0.744113C11.3244 0.812819 11.3638 0.905512 11.3655 1.00266C11.3672 1.09981 11.3312 1.19384 11.2649 1.26492Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
